import React, { useEffect } from 'react';
import RiddleHistory from './RiddleHistory';
import './RiddleHistoryModal.css';

const RiddleHistoryModal = ({ isOpen, onClose, riddles }) => {
  useEffect(() => {
    if (!isOpen) return;

    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', onKeyDown);

    // Prevent background scroll on mobile while modal is open.
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      window.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = prevOverflow;
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="riddle-history-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Riddle history"
      onMouseDown={(e) => {
        // Click outside to close
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div className="riddle-history-modal" onMouseDown={(e) => e.stopPropagation()}>
        <div className="riddle-history-modal__header">
          <h3 className="riddle-history-modal__title">Riddle history</h3>
          <button
            type="button"
            className="riddle-history-modal__close"
            onClick={onClose}
            aria-label="Close riddle history"
          >
            ×
          </button>
        </div>

        <div className="riddle-history-modal__body">
          <RiddleHistory riddles={riddles} />
        </div>
      </div>
    </div>
  );
};

export default RiddleHistoryModal;

